import { isNullOrEmpty } from 'helpers/generalHelpers';
import React from 'react'

function Select(props) {
  //console.log('Select params', props);

  const className = props.className;
  const options = props.options;
  const defaultOption = props.defaultOption;
  const placeholder = props.placeholder;
  const onChange = props.onChange;
  //console.log('Select', placeholder, defaultOption, options);

  var optionList = [];
  if (typeof options !== 'object') {
    var index = 0;
    options.forEach(o => {
        const opt = {
            value: index.toString(),
            label: options[index]
        }
        optionList.push(opt);
        ++index;
    });

  } else {
    optionList.push.apply(optionList,options);
  }

  //console.log('options', optionList);

  function change(e) {
    const t = e.target;
    var ix = t.selectedIndex;
    //console.log('change', e);
    //console.log('change', t);
    //console.log('change', t.value, t.selectedIndex);
    if (!onChange) return;
    if (placeholder && !defaultOption) ix = ix -1;
    onChange(ix);
  }

  return (
    <div className={className}>
        <select
            className='w-full text-lg font-semibold'
            onChange={(e)=>change(e)}
            defaultValue={defaultOption ? defaultOption : placeholder}
        >
          { (placeholder && !defaultOption) &&
            <option
              disabled
            >
              {placeholder}
            </option>
          }
          {optionList.map((ol, ix) => {
              //const sel = (ol.value === defaultOption);
              //selected={sel?'selected':null}
              //console.log('optionList', sel, ol.value, defaultOption)
              return (
                <option 
                    value={ol.value} 
                    key={ix}
                    >
                    {ol.label}
                </option>
              )
            })
          }
        </select>

    </div>
  )
}

export default Select